import { Icons } from "@/components/ui/icons";
import { Button } from "@/components/ui/button";
import { AgentAvatar } from "./agent-avatar";
import { cn } from "@/lib/cn";

/**
 * Workshop: Agent dock — shows active agent avatars with add button and count.
 */

interface Agent {
  id: string;
  letter: string;
  statusColor?: string;
  color?: string;
}

interface AgentDockProps {
  agents: Agent[];
  onAddAgent?: () => void;
  className?: string;
  "data-testid"?: string;
}

export function AgentDock({
  agents,
  onAddAgent,
  className,
  "data-testid": testId = "agent-dock",
}: AgentDockProps) {
  return (
    <div
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border border-glass-stroke bg-glass-fill p-1 shadow-glass backdrop-blur-glass",
        className,
      )}
      data-testid={testId}
    >
      {agents.length > 0 && (
        <div className="flex items-center" data-testid="agent-avatars">
          {agents.map((agent, index) => (
            <AgentAvatar
              key={agent.id}
              letter={agent.letter}
              color={agent.color}
              statusColor={agent.statusColor}
              size="default"
              className={cn(index > 0 && "-ml-1.5")}
              data-testid={`agent-avatar-${agent.id}`}
            />
          ))}
        </div>
      )}

      <Button
        variant="ghost"
        size="icon"
        onClick={onAddAgent}
        aria-label="Add agent"
        className="h-7 w-7 shrink-0 rounded-full"
        data-testid="agent-dock-add"
      >
        <Icons.Plus className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}

export type { Agent, AgentDockProps };
